module.exports = __webpack_public_path__ + "static/img/bg_earth.f558f322.png";